module.exports = __webpack_public_path__ + "static/media/booking-header-bg.59f20813.png";